var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlusLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.6,
    height: 19.6
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.72 8.92h-8v-8a.88.88 0 00-1.76 0v8h-8a.88.88 0 000 1.76h8v8a.88.88 0 101.76 0v-8h8a.88.88 0 000-1.76z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOS42IiBoZWlnaHQ9IjE5LjYiIHZpZXdCb3g9IjAgMCAxOS42IDE5LjYiPgogIDxwYXRoIGQ9Ik0xOC43Miw4LjkyaC04di04YS44OC44OCwwLDAsMC0xLjc2LDB2OGgtOGEuODguODgsMCwwLDAsMCwxLjc2aDh2OGEuODguODgsMCwxLDAsMS43Niwwdi04aDhhLjg4Ljg4LDAsMCwwLDAtMS43NloiLz4KPC9zdmc+Cg==";
export { SvgPlusLarge as ReactComponent };